import { apiCall } from './gqlClient';
const GETSECTIONS_QUERY = "\n  query getSections($productId: String!) {\n    getSections(productId: $productId)\n    {\n      id\n\t\t\tname\n\t\t\torderIndex\n\t\t\tproductId\n\t\t\tvideoCourseId\n\t\t\tnumberOfFiles\n\t\t\tavailableAfter\n\t\t\tperiodType\n\t\t\tuserEmail\n\t\t\tuserLanguage\n\t\t\tvideoName\n      ...fragments\n    }\n  }";
export const getSectionsApiCall = async function (_ref) {
  let {
    productId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSECTIONS_QUERY,
    variables: {
      productId
    },
    fragments
  });
};
const SAVESECTION_QUERY = "\n  mutation saveSection($name: String!, $productId: String, $id: String, $availableAfter: Int, $periodType: String) {\n    saveSection(name: $name, productId: $productId, id: $id, availableAfter: $availableAfter, periodType: $periodType)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const saveSectionApiCall = async function (_ref2) {
  let {
    name,
    productId,
    id,
    availableAfter,
    periodType
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVESECTION_QUERY,
    variables: {
      name,
      productId,
      id,
      availableAfter,
      periodType
    },
    fragments
  });
};
const DELETESECTION_QUERY = "\n  mutation deleteSection($id: String!) {\n    deleteSection(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const deleteSectionApiCall = async function (_ref3) {
  let {
    id
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETESECTION_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const ADDFILEINTOSECTION_QUERY = "\n  mutation addFileIntoSection($sectionId: String!, $fileId: String!, $intro: Boolean!, $free: Boolean!) {\n    addFileIntoSection(sectionId: $sectionId, fileId: $fileId, intro: $intro, free: $free)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const addFileIntoSectionApiCall = async function (_ref4) {
  let {
    sectionId,
    fileId,
    intro,
    free
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ADDFILEINTOSECTION_QUERY,
    variables: {
      sectionId,
      fileId,
      intro,
      free
    },
    fragments
  });
};
const REMOVEFILEFROMSECTION_QUERY = "\n  mutation removeFileFromSection($sectionId: String!, $fileId: String!) {\n    removeFileFromSection(sectionId: $sectionId, fileId: $fileId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const removeFileFromSectionApiCall = async function (_ref5) {
  let {
    sectionId,
    fileId
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REMOVEFILEFROMSECTION_QUERY,
    variables: {
      sectionId,
      fileId
    },
    fragments
  });
};
const REORDERSECTIONS_QUERY = "\n  mutation reorderSections($videoCourseId: String!, $oldPosition: Int!, $newPosition: Int!) {\n    reorderSections(videoCourseId: $videoCourseId, oldPosition: $oldPosition, newPosition: $newPosition)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const reorderSectionsApiCall = async function (_ref6) {
  let {
    videoCourseId,
    oldPosition,
    newPosition
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REORDERSECTIONS_QUERY,
    variables: {
      videoCourseId,
      oldPosition,
      newPosition
    },
    fragments
  });
};
const DUPLICATESECTION_QUERY = "\n  mutation duplicateSection($id: String!, $videoId: String!) {\n    duplicateSection(id: $id, videoId: $videoId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const duplicateSectionApiCall = async function (_ref7) {
  let {
    id,
    videoId
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DUPLICATESECTION_QUERY,
    variables: {
      id,
      videoId
    },
    fragments
  });
};